export const RouterPath = {
  LOGIN: '/login',
  JOIN: '/join',
  PWDSET: '/pwdset',
  HOME: '/home',
  PIN: '/pin',
  SETTING: '/setting',
}


